import * as types from "../constants/actionConstants";
import IntegrationApi from "../api/IntegrationApi";

export function initializeEditorEdit(integration) {
    return {
        type: types.INTEGRATION_EDITOR_INITIALIZE,
        payload: {
            integration: integration,
            options: {
                createMode: false,
                validate: [],
                isValidating: false
            }
        }
    };
}

export function getIntegration(id) {
    return (dispatch) => {
        dispatch({type: types.INTEGRATION_EDITOR_GET_INIT, id});
        IntegrationApi.getIntegrationById(id).then((integration) => {
            dispatch({type: types.INTEGRATION_EDITOR_GET_SUCCESS, integration});
        });
    };
}

export function updateIntegrationStore(integration, options) {
    return {
        type: types.INTEGRATION_EDITOR_UPDATE_STORE,
        payload:{
            integration,
            options
        }
    };
}

export function clearEditor() {
    return {
        type: types.INTEGRATION_EDITOR_CLEAR
    };
}

// export function addIntegration(question) {
//     return {
//         type: types.INTEGRATION_EDITOR_ADD,
//         question
//     };
// }

export function validateIntegrationNameUnique(name) {
    return (dispatch) => {
        dispatch({type: types.INTEGRATION_EDITOR_NAME_VALIDATING});
        dispatch(checkIntegrationNameExists(name))
    };
}

export function checkIntegrationNameExists(name) {
    return (dispatch) => {
        IntegrationApi.checkIntegrationNameExists(name).then((integration) => {
            dispatch({type: types.INTEGRATION_EDITOR_NAME_EXISTS, integration});
        });
    };
}

